import Api from "../../lib/api";
import { UserDataHelper } from "../../lib/user-data-helper";
import EventEmitter from "../../components/base/event-emitter";

export class PostStatistics extends EventEmitter {
	constructor(props) {
		super(props);

		this.$postStats = document.getElementById('heroPostStats');
		this.$eventTarget = this.$postStats;
		this.$postStatsContent = null;
		this.$likesWrapper = null;
		this.$views = null;
		this.$likes = null;

		this.views = null;
		this.likes = null;

		this.STATISTICS_LOADED_EVENT = 'statisticsLoaded';

		this.init();
	}

	init() {
		this.$postStatsContent = this.$postStats.querySelector('.hero-stats_content');
		const $spinner = this.$postStats.querySelector('.spinner');

		this.$views = this.$postStats.querySelector('.post-stats-views');
		this.$likes = this.$postStats.querySelector('.post-stats-likes');
		this.$likesWrapper = this.$likes.parentElement;

		// Get post statistics, update activity,
		// and check if the post is liked
		this.getStatistics().then((data) => {
			if (data.payload) {
				this.$views.textContent = data.payload.views;
				this.$likes.textContent = data.payload.likes;

				if (data.payload.views == 0 && data.payload.likes == 0) {
					this.$postStatsContent.classList.add('-no-likes-views');
				} else if (data.payload.likes == 0) {
					this.hideLikes();
				}
			} else {
				this.$postStatsContent.classList.add('-no-likes-views');
			}

			// Remove spinner and show view after content has been loaded
			$spinner.remove();
			this.$postStatsContent.style.opacity = 1;

			this.dispatchEvent(this.STATISTICS_LOADED_EVENT);
		});
	}

	getStatistics() {
		return Api.get(Api.apiSiteUrl + `/site/blog/statistics/${craft.page.entryId}`)
			.catch((err) => {
				console.error(err);
			});
	}

	hideLikes() {
		this.$likesWrapper.style.display = 'none';
	}

	showLikes() {
		this.$likesWrapper.removeAttribute('style');
	}
}

export default class UserActivity {
	constructor() {
		this.$buttonLike = document.getElementById('buttonLike');

		this.statisticsModule = null;
		this.liked = false;

		if (this.$buttonLike) {
			this.init();
		}
	}

	init() {
		this.updateActivity().then(({ data }) => {
			this.liked = data.payload.liked;

			if (this.liked) {
				this.$buttonLike.classList.add('-active');
			} else {
				this.$buttonLike.classList.remove('-active');
			}

			this.addEventListeners();
			this.statisticsModule = new PostStatistics();
		});
	}

	addEventListeners() {
		if (this.$buttonLike) {
			this.$buttonLike.addEventListener('click', () => {
				if (this.$buttonLike.classList.contains('-active')) {
					this.updateActivity({ withLike: false });
					this.$buttonLike.classList.remove('-active');

					// Update likes view
					let likes = +this.statisticsModule.$likes.textContent;
					this.statisticsModule.$likes.textContent = --likes;

					if (likes == 0) {
						this.statisticsModule.hideLikes();
					}
				} else {
					this.updateActivity({ withLike: true });
					this.$buttonLike.classList.add('-active');

					// Update likes view
					let likes = +this.statisticsModule.$likes.textContent;
					this.statisticsModule.$likes.textContent = ++likes;

					if (likes > 0) {
						this.statisticsModule.showLikes();
					}
				}
			});
		}
	}

	updateActivity(options = {}) {
		const withLike = options.withLike == null ? null : options.withLike;
		const onSuccess = options.onSuccess || false;

		const postData = {
			uuid: UserDataHelper.getUUID(),
			cid: UserDataHelper.getCID()
		};

		// Absence of liked value in post data prevents updating of the post 'like' state
		if (withLike != null && typeof withLike === 'boolean') {
			postData.liked = withLike;
		}

		return Api.post(Api.apiSiteUrl + `/site/blog/activity/${craft.page.entryId}`, postData)
			.catch((err) => {
				console.error(err);
			});
	}
}